import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider, TextField, Grid, Typography, Box, CircularProgress } from "@mui/material"

import { getPharmaorderStruct, setData } from './PharmaorderStruct'
import { updateTextValue, handleSubmit, updateValue, updateSelectedValue } from '../../core/js/FormUtils'
import { createAPI, updateAPI, getAPI, updateEditableAPI } from './PharmaorderAPI';
import { CoreContext } from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { validMobileNumberEntry, validNameEntry, validEmailEntry } from '../../core/js/FormValidation';

import { getPathVariable } from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch, useSelector } from 'react-redux';
import { updatePharmaorderObj, addPharmaorderObj, setShowEditForPharmaorder } from 'store/slice/PharmaSlice';
import { addOrderAPI, updateOrderAPI } from '../../api/OmsOrdermgmtWebServices';
import { setApiInProgress } from 'store/slice/HeaderSlice';



export default function PharmaorderEditFormOnly() {
    const dispatch = useDispatch();
    const { setNotification, lastURL } = React.useContext(CoreContext);
    const [formValues, setFormValues] = useState(getPharmaorderStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const { apiInProgress } = useSelector((state) => state.headerslice)
    const { pharmaorderDashboard } = useSelector((state) => state.pharmaslice);
    const [pharmaorderId, setPharmaorderId] = useState(pharmaorderDashboard.selectedId);
    const { editorderModalOpen } = useSelector((state) => state.pharmaslice.pharmaorderDashboard);
    const { businessid, username } = useSelector((state) => state.headerslice.userprofileInfo)

    const { partyList } = useSelector((state) => state.pharmaslice);
    const handleDynamicSelectedValueForpartyid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'partyname', partyList.find(obj => obj.id === e.target.value).name);
    }
    useEffect(() => {
    }, [apiInProgress])

    useEffect(() => {
        if (pharmaorderId !== -1) {
            if (dataLoaded) return;
            getAPI(pharmaorderId, loadForm);
        }
        else {
            // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }
        setFormValues({
            ...formValues,
            ['businessid']: {
                ...formValues['businessid'],
                value: businessid
            },
            ['title']: {
                ...formValues['title'],
                value: businessid
            }
        })
    }, []);

    const loadForm = (data) => {
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value)
            return "yes"
        else
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value === "yes")
            return true
        else
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        updateTextValue(formValues, setFormValues, e);
    }

    const handleNameChange = (e) => {
        setShowError(false);

        if (validNameEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);

        if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);

        if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }

    const createSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(addPharmaorderObj(obj.pharmaorderInfo));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(setShowEditForPharmaorder(false));
    }
    const updateSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(updatePharmaorderObj(obj.pharmaorderInfo));
        setNotification('Record with id[' + pharmaorderId + '] has been updated successfully !!!');
        //if (!editorderModalOpen)
        dispatch(setShowEditForPharmaorder(false));

    }
    const failuerCallback = (errorMsg) => {
        dispatch(setApiInProgress(false));
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const callAddOrderWebService = (formValues) => {
        dispatch(setApiInProgress(true));
        addOrderAPI(
            {
                "partyId": formValues.partyid.value,
                "dispatchDate": formValues.dispatchdate.value,
                "executiveName": username
            }, createSuccessCallback, failuerCallback);
    }
    const callUpdateOrderWebService = () => {
        dispatch(setApiInProgress(true));
        updateOrderAPI({
            "pharmaorderinfo": {
                "id": formValues.id.value,
                "orderid": pharmaorderId,
                "partyid": formValues.partyid.value,
                "dispatchdate": formValues.dispatchdate.value
            }
        }, updateSuccessCallback, failuerCallback);
    }
    const onSubmit = (e) => {
        dispatch(setApiInProgress(true));
        handleSubmit(e, pharmaorderId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, callAddOrderWebService, callUpdateOrderWebService);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);

        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr = date.getFullYear() + "-" + monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    return (
        <form noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25} sx={{ backgroundColor: 'white', height: (window.screen.height * 0.80 - 300) + 'px' }}>
                {showError ? <Alert severity="error">{errorMsg}</Alert> : ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{ overflowY: "scroll" }}>
                        <Grid container direction="column" padding={.25}>
                            <Grid item>
                                <Typography variant='h4'>Order {pharmaorderId === -1 ? 'Add' : 'Edit'}</Typography>
                                <Divider />
                            </Grid>
                            <Grid height='25px' ></Grid>
                            {dataLoaded ?
                                <Grid container display="flex" spacing={2} padding={1} direction="row" justifyContent="space-between" alignItems="center">
                                    <Grid item lg={8} xs={12}>
                                        <FormControl sx={{ width: '100%', paddingBottom: formValues.dispatchdate.value == '' ? 2 : 0 }} size="Normal">
                                            <InputLabel id="demo-simple-select-autowidth-label">Party Name</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-autowidth-label"
                                                id="demo-simple-select-autowidth"
                                                label={formValues.partyid.label}
                                                name={formValues.partyid.name}
                                                value={formValues.partyid.value}
                                                onChange={handleDynamicSelectedValueForpartyid}

                                                error={formValues.partyid.error}
                                                helpertext={formValues.partyid.error && formValues.partyid.errorMessage}
                                            >
                                                <MenuItem key={0} value="0">Select Item</MenuItem>
                                                {
                                                    partyList && partyList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item lg={4} xs={12} sx={{ paddingBottom: formValues.dispatchdate.value == '' ? '15px' : '' }}>
                                        <MyDate
                                            label={formValues.dispatchdate.label}
                                            fieldName={formValues.dispatchdate.name}
                                            defaultValue={formValues.dispatchdate.value}
                                            errStr={formValues.dispatchdate.errorMessage}
                                            setDate={setDate}

                                        />
                                    </Grid>



                                    <Grid item lg={4} xs={12}>
                                        <TextField size="small"
                                            placeholder={formValues.executivename.placeholder}
                                            required={formValues.executivename.required}
                                            label={formValues.executivename.label}
                                            name={formValues.executivename.name}
                                            value={formValues.executivename.value}
                                            onChange={handleTextChange}
                                            error={formValues.executivename.error}
                                            helpertext={formValues.executivename.error && formValues.executivename.errorMessage}
                                            sx={{ paddingBottom: 2, width: '100%', display: 'none' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12}>
                                        <TextField size="small"
                                            placeholder={formValues.popath.placeholder}
                                            required={formValues.popath.required}
                                            label={formValues.popath.label}
                                            name={formValues.popath.name}
                                            value={formValues.popath.value}
                                            onChange={handleTextChange}
                                            error={formValues.popath.error}
                                            helpertext={formValues.popath.error && formValues.popath.errorMessage}
                                            sx={{ paddingBottom: 2, width: '100%', display: 'none' }}
                                        />
                                    </Grid>
                                    <Grid item lg={4} xs={12}>
                                        <TextField size="small"
                                            placeholder={formValues.poid.placeholder}
                                            required={formValues.poid.required}
                                            label={formValues.poid.label}
                                            name={formValues.poid.name}
                                            value={formValues.poid.value}
                                            onChange={handleTextChange}
                                            error={formValues.poid.error}
                                            helpertext={formValues.poid.error && formValues.poid.errorMessage}
                                            sx={{ paddingBottom: 2, width: '100%', display: 'none' }}
                                        />
                                    </Grid>
                                    <Grid item lg={4} xs={12}>
                                        <TextField size="small"
                                            placeholder={formValues.partyname.placeholder}
                                            required={formValues.partyname.required}
                                            label={formValues.partyname.label}
                                            name={formValues.partyname.name}
                                            value={formValues.partyname.value}
                                            onChange={handleTextChange}
                                            error={formValues.partyname.error}
                                            helpertext={formValues.partyname.error && formValues.partyname.errorMessage}
                                            sx={{ paddingBottom: 2, width: '100%', display: 'none' }}
                                        />
                                    </Grid>
                                    <Grid item lg={4} xs={12}>
                                        <TextField size="small"
                                            placeholder={formValues.orderid.placeholder}
                                            required={formValues.orderid.required}
                                            label={formValues.orderid.label}
                                            name={formValues.orderid.name}
                                            value={formValues.orderid.value}
                                            onChange={handleTextChange}
                                            error={formValues.orderid.error}
                                            helpertext={formValues.orderid.error && formValues.orderid.errorMessage}
                                            sx={{ paddingBottom: 2, width: '100%', display: 'none' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12}>
                                        <TextField size="small"
                                            placeholder={formValues.ordervalue.placeholder}
                                            required={formValues.ordervalue.required}
                                            label={formValues.ordervalue.label}
                                            name={formValues.ordervalue.name}
                                            value={formValues.ordervalue.value}
                                            onChange={handleTextChange}
                                            error={formValues.ordervalue.error}
                                            helpertext={formValues.ordervalue.error && formValues.ordervalue.errorMessage}
                                            sx={{ paddingBottom: 2, width: '100%', display: 'none' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12} sx={{ width: '100%', display: 'none' }}>
                                        <FormControl sx={{ width: { lg: '100%', xs: '200px' }, paddingBottom: 2 }} size="small">
                                            <InputLabel id="demo-simple-select-autowidth-label">{formValues.orderstatus.label}</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-autowidth-label"
                                                id="demo-simple-select-autowidth"
                                                label={formValues.orderstatus.label}
                                                name={formValues.orderstatus.name}
                                                value={formValues.orderstatus.value}
                                                onChange={handleTextChange}

                                                error={formValues.orderstatus.error}
                                                helpertext={formValues.orderstatus.error && formValues.orderstatus.errorMessage}
                                            >

                                                <MenuItem value="DRAFT">DRAFT</MenuItem>
                                                <MenuItem value="UNDER APPROVAL">UNDER APPROVAL</MenuItem>
                                                <MenuItem value="APPROVED">APPROVED</MenuItem>
                                                <MenuItem value="UNDER DELIVERY">UNDER DELIVERY</MenuItem>
                                                <MenuItem value="DELIVERED">DELIVERED</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item lg={4} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.title.placeholder}
                                            required={formValues.title.required}
                                            label={formValues.title.label}
                                            name={formValues.title.name}
                                            value={formValues.title.value}
                                            onChange={handleTextChange}
                                            error={formValues.title.error}
                                            helpertext={formValues.title.error && formValues.title.errorMessage}
                                            sx={{ width: '100%', display:'none' }}
                                        />
                                    </Grid>
                                </Grid>
                                : <></>}
                        </Grid>
                    </Grid>
                    {/* <Grid height='25px' ></Grid>
                    <Grid >
                        <Divider />
                    </Grid> */}
                    <Grid container direction="row" justifyContent="flex-end"  >
                        {apiInProgress ? <CircularProgress /> :
                            <>
                                <Button variant="outlined" sx={{ backgroundColor: 'white' }} type="submit" >{pharmaorderId === -1 ? 'Add' : 'Save'}</Button>&nbsp;&nbsp;&nbsp;
                                <Button variant="outlined" sx={{ backgroundColor: 'white' }} onClick={() => { dispatch(setShowEditForPharmaorder(false)); }}>Close</Button>
                            </>
                        }
                    </Grid>
                </Box>

            </Grid>
        </form>
    );
};